/**
 * ANQ.UserProfile.API 
 * User Profile Service
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AuthenticationStatus } from './authenticationStatus';

export interface UserAuthenticationResponse { 
    readonly success?: boolean;
    status?: AuthenticationStatus;
    errors?: Array<string>;
    token?: string;
    username?: string;
    userId?: string;
    roleId?: number;
    roleName?: string;
    firstName?: string;
    tenantId?: string;
    accountSetup?: boolean;
}